/* eslint-disable complexity */
function getEntryType(entry) {

  if (/\.(woff2?|ttf)$/.test(entry.name)) {
    return 'fonts__files';
  }

  if (/(font[^?]+\.css|fonts\.googleapis\.com\/css)/.test(entry.name)) {
    return 'fonts__css';
  }

  if (entry.initiatorType === 'img') {
    if (/frog\.wix/.test(entry.name)) {
      return 'requests__BI';
    }

    if (/images-vod(-test)?\.wix(mp)?\.com/.test(entry.name)) {
      return 'images__resized_from_vod_wixmp_com';
    }

    if (/\.(jpe?g|gif|tiff|ttf|png)/.test(entry.name)) {
      return 'images__other';
    }
  }

  if (entry.entryType === 'navigation') {
    if (/wix-vod[^?]+\.html/.test(entry.name)) {
      return 'htmls__app';
    }

    if (/\.html/.test(entry.name)) {
      return 'htmls__other';
    }
  }

  if (entry.initiatorType === 'script') {
    if (/(newrelic|nr-data.net)[^?]/.test(entry.name)) {
      return 'js__newrelic';
    }

    if (/react-intl-data|translations/.test(entry.name)) {
      return 'js__translations';
    }

    if (/static\.parastorage\.com[^?]+vod[^?]+/.test(entry.name)) {
      return 'js__vod_bundles_from_parastorage';
    }

    if (/static\.parastorage\.com[^?]+(third-party|services)/.test(entry.name)) {
      return 'js__vendors_from_parastorage';
    }
  }

  if (entry.initiatorType === 'xmlhttprequest') {
    if (/wix-laboratory-server/.test(entry.name)) {
      return 'requests__experiments';
    }

    if (/nr-data.net/.test(entry.name)) {
      return 'requests__newrelic';
    }

    if (/vod(-test)?\.wix\.com/.test(entry.name)) {

      if (/lists\/[^/?]+\/member\/info/.test(entry.name)) {
        return 'requests__vod_member_info';
      }

      if (/lists\/[^/?]+\/?(\?|$)/.test(entry.name)) {
        return 'requests__vod_channel_videos';
      }

      if (/lists\/[^/]+\/info/.test(entry.name)) {
        return 'requests__vod_channel_info';
      }

      return 'requests__vod_other';
    }
  }

  return `unknown__${entry.initiatorType}`;
}

export default function getEntriesLoadingStat() {
  if (!window.performance || !window.performance.getEntries || !window.PerformanceResourceTiming) {
    return {
      isEntriesLoadingStatVisible: 0,
    };
  }

  // eslint-disable-next-line lodash/unwrap
  const _entriesByDataTypes = _(window.performance.getEntries())
    .filter(entry => entry instanceof window.PerformanceResourceTiming)
    .groupBy(getEntryType);

  const counts = _entriesByDataTypes
    .mapKeys((value, type) => `entries__${type}__count`)
    .mapValues(entries => entries.length)
    .value();

  const durations = _entriesByDataTypes
    .mapKeys((value, type) => `entries__${type}__total_duration`)
    .mapValues(entries => _.sumBy(entries, 'duration'))
    .value();

  return {
    isEntriesLoadingStatVisible: 1,
    ...counts,
    ...durations,
  };
}



// WEBPACK FOOTER //
// ./src/shared/utils/performance/entries-loading-stat.js